'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Load this dynamically so that it
 * doesn't appear in the rollup bundle.
 */

var features = exports.features = require('../../data/features');


//////////////////
// WEBPACK FOOTER
// ./~/caniuse-lite/dist/unpacker/features.js
// module id = 1201
// module chunks = 0